import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'
import { ConfigProvider } from 'antd'
import locale from 'antd/lib/locale/ko_KR'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import 'dayjs/locale/ko'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import Routers from 'routers/router'
import AppLayout from 'layout/appLayout'
import TokenConfig from 'utils/tokenConfig'

import 'assets/scss/ui.scss'

const gaTrackingId = process.env.REACT_APP_GA_TRACKING_ID // 환경 변수에 저장된 GA4 추적 ID 가져오기
ReactGA.initialize(gaTrackingId) // GA4 초기화
dayjs.locale('ko') // antd datepicker 한글화
dayjs.extend(utc) // UTC 플러그인 적용하기
dayjs.extend(timezone) // 한국 타임존 적용
dayjs.extend(isBetween) // 현재 날짜가 중간에 위치하는지 확인하는 플러그인
dayjs.tz.setDefault('Asia/Seoul')

const App = () => {
    const location = useLocation()

    // 페이지 경로가 변경될 때마다 GA 페이지뷰 전송 (GA4)
    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search }) // 페이지 경로 + 쿼리 파라미터를 포함하여 페이지 뷰 전송
    }, [location.pathname]) // 페이지 경로 변경 시마다 호출

    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: TokenConfig(),
                hashed: false,
            }}
        >
            <AppLayout>
                <Routers />
            </AppLayout>
        </ConfigProvider>
    )
}

export default App
